import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(p){ super(p); this.state = { hasError:false, err:null }; }
    static getDerivedStateFromError(err){ return { hasError:true, err }; }
    componentDidCatch(err, info){ console.error('UI crashed:', err, info); }
    render(){
        if (this.state.hasError) return (
            <div style={{padding:16,color:'#b00',fontFamily:'monospace'}}>
                <h3>Something broke in the UI.</h3>
                <pre>{String(this.state.err)}</pre>
            </div>
        );
        return this.props.children;
    }
}